import script from "./NewsPageBodyPostFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageBodyPostFooter.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageBodyPostFooter.vue?vue&type=style&index=0&id=0c07710e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c07710e"]])

export default __exports__